<div
  role="button"
  dropzone
  [multiple]="multiple()"
  (selectedFiles)="onFileSelected($event)"
  [accept]="accept()"
  class="drop-zone d-flex flex-column align-items-center s-p-5 border bg-primary-soft-background border-clr-primary-brand-color"
>
  <div
    class="bg-primary-brand-color c-white border rounded-circle s-w-12 s-h-12 d-flex align-items-center justify-content-center s-grow-1"
  >
    <mat-icon> attach_file </mat-icon>
  </div>
  <strong class="c-primary-brand-color s-mt-4">
    {{ "file-add" | transloco }}...
  </strong>
</div>
<div class="s-mt-3">
  <app-file-uploader-item
    *ngFor="let file of localFiles"
    [file]="file"
    (remove)="removeItem($event)"
  >
  </app-file-uploader-item>
</div>
